import React, { useEffect, useState } from 'react'
import { Breadcrumb } from '@douyinfe/semi-ui'
import { MenuItem } from '@src/api/common/menu'
import { useLocation } from 'react-router-dom'
import { useLocale } from '@src/locales'
import useMenuStore from '@src/store/common/menu'

interface BreadcrumbItem {
	key: string
	path?: string
	title: string
}

const { Item } = Breadcrumb
let breadcrumbList: BreadcrumbItem[] = []
let end = false

// 根据pathname找出面包屑路径
const getBreadcrumbByPathName = (menuList: MenuItem[], pathname: string, breadcrumbs: BreadcrumbItem[] = []) => {
	for (const menu of menuList) {
		const list: BreadcrumbItem[] = []
		if (!end) {
			list.push({
				key: menu.itemKey,
				path: menu.path,
				title: menu.text
			})
			if (menu.path == pathname) {
				breadcrumbList = breadcrumbs.concat(list)
				end = true
				break
			} else if (menu.items) {
				getBreadcrumbByPathName(menu.items, pathname, breadcrumbs.concat(list))
			}
		}
	}
}

const Index: React.FC = () => {
	const { menuList, loading } = useMenuStore()

	const { pathname } = useLocation()
	const { formatMessage: i18nMsg } = useLocale()
	const [_, setState] = useState(1)
	useEffect(() => {
		if (loading || !menuList.length) return
		end = false
		if (pathname === '/') getBreadcrumbByPathName(menuList, '/order-list')
		else getBreadcrumbByPathName(menuList, pathname)
		setState((state) => state + 1)
	}, [menuList, loading, pathname])

	return (
		<Breadcrumb className="layout-breadcrumb">
			{breadcrumbList.map((e) => {
				return <Item key={e.key}>{i18nMsg({ id: e.title })}</Item>
			})}
		</Breadcrumb>
	)
}

export default Index
